<script setup>
import Layout from '@vuepress/theme-default/layouts/Layout.vue'
</script>

<template>
  <div class="spotlight-page">
    <Layout />
  </div>
</template>

<style scoped>
.spotlight-page {
  background-color: var(--p-surface-50);
  min-height: 100vh;
}

html[data-theme="dark"] .spotlight-page {
  background-color: var(--p-surface-950);
}
</style>
